import { Stack, useTheme } from "@mui/material";
import { MainScore } from "./MainScore";
import { ScoreComparison } from "../ScoreComparison";
import { useTranslation } from "react-i18next";
import { ScoreImprovement } from "src/types";
import SpecificityRateDisplay from "src/components/Subscore/SpecificityRate/SpecificityRateDisplay.tsx";
import { NumericalScoreValue } from "src/api/client-api/olapScores/olapScoresSchema";

type ScoreSummaryProps = {
    appearance?: "legacy" | "product-v2";
    score: NumericalScoreValue | undefined;
    prevScoreValue: NumericalScoreValue | undefined;
    prevCampaign: string | undefined;
    referenceScore: number | undefined;
    referenceName?: string;
    unit: string | undefined;
    improvement: ScoreImprovement;
    specificityRate: NumericalScoreValue | undefined;
    precision: number;
};
export const ScoreSummary = (props: ScoreSummaryProps) => {
    const theme = useTheme();
    const { t } = useTranslation();

    const {
        score = null,
        appearance = "legacy",
        unit,
        prevScoreValue,
        prevCampaign,
        referenceScore,
        referenceName,
        improvement,
        specificityRate = undefined,
        precision,
    } = props;

    const isPrevScoreValid = prevScoreValue !== undefined && prevScoreValue !== null;
    const referenceReportName =
        referenceName !== undefined ?
            t("product.v2.score_live.total.reference_with_name", {
                defaultValue: "ref. {{name}} (Agribalyse)",
                name: referenceName,
            })
        :   t("score_reference.the_reference");

    return (
        <Stack gap={theme.spacing(1)}>
            <MainScore
                appearance={appearance}
                score={{
                    value: score,
                    unit: unit,
                }}
                referenceScore={referenceScore}
                precision={precision}
            />

            {isPrevScoreValid && (
                <ScoreComparison
                    improvement={improvement}
                    scoreValueToCompare={score}
                    referenceScoreValue={prevScoreValue}
                    unit={unit}
                    reportName={prevCampaign ?? ""}
                />
            )}

            {referenceScore !== undefined && (
                <ScoreComparison
                    improvement={improvement}
                    scoreValueToCompare={score}
                    referenceScoreValue={referenceScore}
                    unit={unit}
                    reportName={referenceReportName}
                />
            )}
            <SpecificityRateDisplay appearance={appearance} specificityRate={specificityRate} />
        </Stack>
    );
};
